<div class="alert alert-info border-0" role="status">
	<h5 class="me-4">The {{sourceField.charTypeID | charTypeName}} Source Field
		<strong>{{sourceField.sourceFieldName}}</strong> is used in {{sourceField.usedIn.length}} templates:
	</h5>
	<ul class="mb-0 ps-3">
		@for(usedIn of sourceField.usedIn; track $index) {
			<li class="py-1 ps-0">
				{{usedIn.templateLbl}} &bull; {{usedIn.templateSourceFieldGroupLbl}} &bull;
				{{sourceField.sourceFieldName}}
			</li>
		}
	</ul>
</div>